module.exports = __webpack_public_path__ + "static/media/AntarcticaBeta-ExtraCondMed.928d50f4.woff";